import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getMission(c,id)
  {
    const url = apiUrl + 'mission/get/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getCustomerInfo(c,id)
  {
    const url = apiUrl + 'Mission/GetUserInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async submitStartMissionItem(c,items)
  {
    const url = apiUrl + 'MissionItem/SubmitStart';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
  },
  async deleteStartMissionItem(c,mission_item_id)
  {
    const url = apiUrl + 'MissionItem/deleteStart/'+mission_item_id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async submitRejectMissionItem(c,items)
  {
    const url = apiUrl + 'MissionItem/Reject';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getNoOrderReason()
  {
    const url = apiUrl + 'NoOrderReason/get';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getDeliverMissionItemInfo(c,id)
  {
    const url = apiUrl + 'deliverMission/getItemInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getMissionOrders(c,id)
  {
    const url = apiUrl + 'deliverMission/getMission/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async changeDeliverMissionItemStatus(c,{id,status})
  {
      let url = apiUrl + 'deliverMission/changeItemStatus/'+id;
      url += '?status='+status
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getCollectMissionItem(c,id)
  {
      let url = apiUrl + 'deliverMission/getCollectedItems/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getPaymentMissionFullInfo(c,id)
  {
      let url = apiUrl + 'paymentMission/getFullInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getPaymentMissionItemFullInfo(c,id)
  {
      let url = apiUrl + 'paymentMission/getItemFullInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }


};

export default {
  namespaced: true,
  actions
}